import React, { useState, ReactNode, memo } from "react";
import { Box, Button, Typography } from "@mui/material";

interface ErrorBoundaryProps {
    children: ReactNode;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
    const [hasError, setHasError] = useState(false);

    const resetError = () => setHasError(false);

    const handleError = (error: Error, info: React.ErrorInfo) => {
        console.error("ErrorBoundary caught an error:", error, info);
        setHasError(true);
    };

    // Override React's error handling
    React.useEffect(() => {
        const errorListener = (event: ErrorEvent) => {
            console.error("Global error caught:", event.error);
            setHasError(true);
        };
        window.addEventListener("error", errorListener);

        return () => {
            window.removeEventListener("error", errorListener);
        };
    }, []);

    if (hasError) {
        return (
            <Box sx={{ textAlign: "center", padding: 4 }}>
                <Typography variant="h4" color="error">
                    Something went wrong.
                </Typography>
                <Button onClick={resetError}>Retry</Button>
            </Box>
        );
    }

    return <>{children}</>;
};

export default memo(ErrorBoundary);